import { Link, useLocation } from 'react-router-dom'
import { Moon, Sun, ArrowUpRight } from 'lucide-react'
import { useAuth, useTheme } from '@workspace/public-utils'
import BrandMark from '../BrandMark'

const navItems = [
  { label: '당첨결과', path: '/results' },
  { label: '번호분석', path: '/analysis' },
  { label: '구독플랜', path: '/plans' },
  { label: '고객지원', path: '/faq' },
]

export default function LottomdHeader() {
  const { user, logout } = useAuth()
  const { theme, toggleTheme } = useTheme()
  const { pathname } = useLocation()
  return (
    <header className="md-header">
      <a href="#main-content" className="md-skip-link">
        본문으로 건너뛰기
      </a>
      <div className="md-container md-nav">
        <Link to="/" className="md-brand-link" aria-label="로또명당 홈">
          <BrandMark />
          <span className="md-brand-tagline">
            번호를 고르는
            <br />
            좋은 자리
          </span>
        </Link>
        <nav className="md-nav-links" aria-label="주요 메뉴">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              aria-current={
                pathname === item.path || pathname.startsWith(`${item.path}/`) ? 'page' : undefined
              }
            >
              {item.label}
            </Link>
          ))}
        </nav>
        <div className="md-nav-actions">
          <button
            type="button"
            className="md-icon-button"
            onClick={toggleTheme}
            aria-label={theme === 'dark' ? '라이트 모드로 전환' : '다크 모드로 전환'}
          >
            {theme === 'dark' ? <Sun size={18} /> : <Moon size={18} />}
          </button>
          <Link
            className="md-button md-button-outline md-nav-login"
            to={user ? '/dashboard/numbers' : '/auth/login'}
          >
            {user ? '내 번호함' : '로그인'}
            <ArrowUpRight size={15} aria-hidden="true" />
          </Link>
          {user && (
            <button type="button" onClick={logout} className="md-logout">
              로그아웃
            </button>
          )}
        </div>
      </div>
    </header>
  )
}
